(function () {
    'use strict';

    // Accordion
    $('.accordion').each(function () {
        var $accordion = $(this);
        var offset = $(".header").outerHeight();
        var $heading = $accordion.find('.headings');
        var $content = $accordion.find('.content');
        var sectionTop = $accordion.offset().top;

        if ($accordion.hasClass('full-width')) {
            $heading.on('click', function () {
                var activeAccordion = $(this).parent();

                if (activeAccordion.hasClass('active')) {
                    activeAccordion.removeClass('active');
                    activeAccordion.find('.content').slideUp();
                } else {
                    //close all open accordions
                    $(".accordion").find('.content').slideUp("fast");
                    $(".accordion").removeClass('active');
                    activeAccordion.addClass('active');
                    activeAccordion.find('.content').slideDown();
                    setTimeout(function () {
                        sectionTop = activeAccordion.offset().top - offset;
                        if (activeAccordion.hasClass('with-background')) {
                            sectionTop = activeAccordion.find('.content').offset().top - offset;
                        }
                        $('html, body').animate({
                            scrollTop: sectionTop
                        }, 500);
                    }, 500);
                }


            });
        } else {
            $accordion.find('.accordion-heading').on('click', function () {
                $heading = $(this);
                $content = $heading.next('.accordion-content');

                if ($accordion.hasClass('active')) {
                    $content.slideUp("fast");
                    setTimeout(function () {
                        $accordion.removeClass('active');
                    }, 200);
                } else {
                    //close all open accordions
                    $(".accordion").find('.accordion-content').slideUp("fast");
                    $(".accordion").removeClass('active');
                    $accordion.addClass('active');
                    $content.slideDown();
                }

                if ($heading.parent().hasClass("shaping")) {
                    setTimeout(function () {
                        handleHeights();
                    }, 200);
                }
            });
        }
    });

    // Download Centre
    $(".header .append-download").on("click", function () {
        setTimeout(function () {
            $("#download-centre:not(.active) .headings").trigger("click");
        }, 500);
    });

    function handleHeights() {
        var container = $(".equal-height");
        var investmentHighlights = $(".investment-highlights-carousel")
        var iconContainer = investmentHighlights.find(".border-bottom");
        var iconContainerHeight = "";
        var shapingContainers = $(".shaping .bg-lightest-green .writeup > .flex");
        var shapingContainersImage = $(".shaping .bg-lightest-green .writeup > .image");
        var maxHeight = "";

        shapingContainers.css("height", "");
        shapingContainers.each(function () {
            var height = $(this).outerHeight();
            if (height > maxHeight) {
                maxHeight = height;
            }
        });
        shapingContainers.css("height", maxHeight);

        if (window.innerWidth > 840) {
            shapingContainersImage.css("height", "");
            shapingContainersImage.each(function () {
                var height = $(this).outerHeight();
                if (height > maxHeight) {
                    maxHeight = height;
                }
            });
            shapingContainersImage.css("height", maxHeight);
        } else {
            shapingContainersImage.css("height", "");
        }

        setTimeout(function () {

            iconContainer.css("height", "");
            iconContainer.each(function () {
                var height = $(this).outerHeight();
                if (height > iconContainerHeight) {
                    iconContainerHeight = height;
                }
            });
            iconContainer.css("height", iconContainerHeight);

            container.each(function () {
                var headings = $(this).find(".heading");
                var maxHeight = "";

                headings.css("height", "");
                headings.each(function () {
                    var height = $(this).outerHeight();
                    if (height > maxHeight) {
                        maxHeight = height;
                    }
                });
                headings.css("height", maxHeight);
            });

        }, 500);
    }

    function handleEnergyTransitionAccordions() {
        var items = $(".energy-transition-carousel .item");
        var headings = items.find(".heading");

        headings.first().parent().addClass("open").find(".writeup").slideDown();

        headings.on("click", function (key, value) {
            var heading = $(this);
            var item = heading.parent();
            var writeup = item.find(".writeup");

            if (item.hasClass("open")) {
                writeup.slideUp();
                item.removeClass("open");
            } else {
                writeup.slideDown();
                item.addClass("open");

                $('html, body').animate({
                    scrollTop: heading.offset().top - $(".header").outerHeight()
                }, 500);
            }
        });

    }

    handleHeights();
    handleEnergyTransitionAccordions();

    $(window).on('resize', function () {
        handleHeights();
    });

})();